export default "__VITE_ASSET__BwFGHaPc__"